var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('van-overlay',{attrs:{"show":_vm.show,"z-index":"10241"}}),(_vm.show)?_c('van-loading',{attrs:{"size":"50px","color":"#F0F8FF","vertical":""}},[_vm._v("加载中...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }